// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-sparklines-area';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.656 2.808h14.616c.648 0 1.152.504 1.152 1.152v10.152c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V3.96c.072-.648.576-1.152 1.152-1.152zm.936 8.856 2.592-4.32m-.504 4.32 1.512-2.52m.504 2.52.432-.792m1.656.792 1.296-2.16m.72 2.16 3.384-5.616m-1.296 5.616 2.304-3.888m-.288 3.888.288-.432'
  />
);

export const viewBox = '0 0 18 18';
